import i18n, { StringMap, TOptions } from "i18next";

import { initReactI18next } from "react-i18next";
import { convertLanguageJsonToObject } from "./translations";
import en_translation from "./lang/en/translation.json";
import vi_translation from "./lang/vi/translation.json";
import jp_translation from "./lang/jp/translation.json";
import zh_translation from "./lang/zh/translation.json";
import ko_translation from "./lang/ko/translation.json";

export { translations } from "./translations";

export enum ELanguage {
  EN = "en",
  VI = "vi",
  ZH = "zh",
  JP = "jp",
  KO = "ko",
}

const jsonConvert = (json: any) => {
  return JSON.parse(JSON.stringify(json));
};

convertLanguageJsonToObject(en_translation);
export const resources = {
  vi: {
    translation: vi_translation,
  },
  en: {
    translation: en_translation,
  },
  zh: {
    translation: jsonConvert(zh_translation),
  },
  ko: {
    translation: jsonConvert(ko_translation),
  },
  jp: {
    translation: jsonConvert(jp_translation),
  },
} as const;

i18n.use(initReactI18next).init({
  lng: "en",
  resources,
});

export const _t = (id: string): string => {
  if (!id) {
    id = "_NOT_TRANSLATED_";
  }
  return id;
};
export default i18n;

export const I18nTranslator = (
  value?: string,
  options?: TOptions<StringMap>
) => {
  if (!value) {
    return "_TRANSLATION_";
  }
  return i18n.t(_t(value), options);
};
